import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import configsAdmin from '../../../../apis/admin/config.service';

type configsListState = {
    configs: []
    isLoading: boolean
}

const initialState: configsListState = {
    configs: [],
    isLoading: false,
};

export const getconfigsDatas = createAsyncThunk(
    'configs/ListconfigState',
    async () => {
        const response: any = await configsAdmin.getconfigsData();
        return response?.data?.data?.payload
    }
)
export const configSlice = createSlice({
    name: 'configslist',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(getconfigsDatas.pending, (state) => {
                state.isLoading = false
                state.configs = []
            })
            .addCase(getconfigsDatas.fulfilled, (state, action: any) => {
                state.isLoading = true
                state.configs = action.payload
            })
            .addCase(getconfigsDatas.rejected, (state, action) => {
                state.isLoading = true
                state.configs = []
            });
    },
});

export default configSlice.reducer;